export default __webpack_public_path__ + "static/media/banner-3.1e060cf8.jpg";